import { render, staticRenderFns } from "./CustomerAcceptedInquiries.vue?vue&type=template&id=05bec0ec&"
import script from "./CustomerAcceptedInquiries.vue?vue&type=script&lang=js&"
export * from "./CustomerAcceptedInquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports